<template>
  <div>
    <div class="flex__between">
      <div><BlusaltLogo /></div>
      <div class="primary logo-side-text">ACCOUNT STATEMENT</div>
    </div>
    <div class="duration">
      <div class="primary heading">Invoice</div>
      <div class="primary period">{{ duration.from }} - {{ duration.to }}</div>
    </div>
    <div class="d-flex justify-content-between address">
      <div class="w-100 col-4 px-0">
        <div class="from">
          <div class="heading bg--primary">FROM</div>
          <div class="address-info faint-primary-bg text--black">
            Blusalt Financial Limited, <br />
            info@blusalt.net <br />
            (+234) 812 234 5678
          </div>
        </div>
        <div class="mt-4 to">
          <div class="heading bg--primary">TO</div>
          <div class="address-info faint-primary-bg text--black">
            {{ customer.first_name }} {{ customer.last_name }}, <br />
            {{ customer.email }} <br />
            {{ customer.phone }}
          </div>
        </div>
      </div>

      <div class="w-100 col-4 px-0">
        <div class="from">
          <div class="heading bg--primary">NUMBER OF INVOICES</div>
          <div class="address-info faint-primary-bg text--black">
            {{ extra.invoiceCount }}
          </div>
        </div>
        <div class="mt-4 to">
          <div class="heading bg--primary">TOTAL AMOUNT</div>
          <div class="flex__between summaries faint-primary-bg">
            <div class="summary-items black">Invoice Amount</div>
            <div class="summary-items black">
              {{ toCurrency(extra.totalAmount, currency) }}
            </div>
          </div>
          <div class="flex__between summaries faint-primary-bg">
            <div class="summary-items black">Amount Paid</div>
            <div class="summary-items black">
              {{ toCurrency(extra.totalPaid, currency) }}
            </div>
          </div>
          <div class="flex__between summaries faint-primary-bg">
            <div class="summary-items black bold">Total Outstanding</div>
            <div class="summary-items black bold">
              {{ toCurrency(extra.totalOutstandingAmount || 0, currency) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlusaltLogo from "./BlusaltLogo.vue";
import {
  toCurrency,
  humanDateFormat,
} from "../../../../../../../components/utils/helpers";

export default {
  props: ["data", "dates", "extra"],
  components: {
    BlusaltLogo,
  },
  computed: {
    currency() {
      return this.data[0].currency;
    },
    duration() {
      const from = humanDateFormat(this.dates.from);
      const to = humanDateFormat(this.dates.to);

      return { from, to };
    },
    customer() {
      const { email, first_name, last_name, phone } =
        this.data[0].other_info.customer || {};
      return { email, first_name, last_name, phone };
    },
  },
  methods: {
    toCurrency,
  },
};
</script>
